import Vue from "vue";
import Vuex from "vuex";
//import VueLodash from 'vue-lodash'
// import lodash from 'lodash'
//Vue.use(VueLodash, { name: 'custom' , lodash: lodash })


import * as actions from "./actions";
import * as mutations from "./mutations";
import * as getters from "./getters";
import * as initialState from "./initialState"


Vue.use(Vuex);

export const store = new Vuex.Store({
  state:{},
  getters,
  mutations,

  actions,
});

// now hydrate the initial state from the initial state module
store.replaceState(initialState.initialState);